module.exports = __webpack_public_path__ + "static/media/unk-spoonerism-task ().87d9b6a9.mp3";